/**
 * BriefingCirculation.jsx — Wrapper de la route /briefing-circulation
 * Utilise le composant générique <BriefingPage> avec les data du briefing AM/Circulation.
 */
import React from 'react';
import BriefingPage from '../components/BriefingPage';
import { briefing, briefingQuiz } from '../data/briefingCirculation';

export default function BriefingCirculation() {
  return <BriefingPage briefing={briefing} briefingQuiz={briefingQuiz} heroEmoji="🛵" reflexesLabel="Les 5 réflexes du cyclo" />;
}
